'use strict';

const {a, span, ul, li} = require('iblokz-snabbdom-helpers');

/**
 * Hover dropdown (boilerplate / thriftify-style): handle + ul > li.
 */
module.exports = (className, {
	handle,
	handleClick,
	items = [],
	toLeft = false,
	flags = false
}) => {
	const mods = ['.dropdown', className];
	if (toLeft) mods.push('.to-left');
	if (flags) mods.push('.flags');

	const handleNode = flags
		? span('.flag-handle', {
			on: handleClick ? {
				click: ev => {
					ev.preventDefault();
					handleClick();
				}
			} : {}
		}, handle)
		: span('.handle', {
			on: handleClick ? {
				click: ev => {
					ev.preventDefault();
					handleClick();
				}
			} : {}
		}, handle);

	const renderItem = item => {
		if (item.content) return item.content;
		return span(item.label);
	};

	return a(mods.filter(Boolean).join(''), [
		handleNode,
		items.length ? ul(items.map(item => li({
			class: {
				active: !!item.active,
				disabled: !!item.disabled
			},
			on: item.disabled || !item.onSelect ? {} : {
				click: ev => {
					ev.preventDefault();
					item.onSelect();
				}
			}
		}, renderItem(item)))) : null
	]);
};
